import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const integrationsGoogleBusinessAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.IntegrationsView, Permission.IntegrationsModify],
}
